
export class ImageText
{   

    //let 
    private result:Array<PIXI.Sprite>;
    private parent:PIXI.Container;
    private spacing:number;
    private text:string;
    private newTint:number;
    constructor(text:string,parent:PIXI.Container|PIXI.Sprite|PIXI.Graphics)
    {   
        this.newTint=0xfffffff; 
        this.parent= new PIXI.Container();
        parent.addChild(this.parent);
        this.spacing=120;
        this.result=[];
        this.text=text;
        this.buildText(text);
    }


    private buildText=(text:String):void=>
    {
       
        for (let i = 0; i < text.length; i++) {
            if(text[i]=="a"||text[i]=="A"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("a.png"));};
            if(text[i]=="b"||text[i]=="B"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("b.png"));};
            if(text[i]=="c"||text[i]=="C"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("c.png"));};
            if(text[i]=="d"||text[i]=="D"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("d.png"));};
            if(text[i]=="e"||text[i]=="E"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("e.png"));};
            if(text[i]=="f"||text[i]=="F"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("f.png"));};
            if(text[i]=="g"||text[i]=="G"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("g.png"));};
            if(text[i]=="h"||text[i]=="H"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("h.png"));};
            if(text[i]=="i"||text[i]=="I"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("i.png"));};
            if(text[i]=="j"||text[i]=="J"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("j.png"));};
            if(text[i]=="k"||text[i]=="K"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("k.png"));};
            if(text[i]=="l"||text[i]=="L"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("l.png"));};
            if(text[i]=="m"||text[i]=="M"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("m.png"));};
            if(text[i]=="n"||text[i]=="N"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("n.png"));};
            if(text[i]=="o"||text[i]=="O"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("o.png"));};
            if(text[i]=="p"||text[i]=="P"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("p.png"));};
            if(text[i]=="q"||text[i]=="Q"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("q.png"));};
            if(text[i]=="r"||text[i]=="R"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("r.png"));};
            if(text[i]=="s"||text[i]=="S"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("s.png"));};
            if(text[i]=="t"||text[i]=="T"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("t.png"));};
            if(text[i]=="u"||text[i]=="U"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("u.png"));};
            if(text[i]=="v"||text[i]=="V"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("v.png"));};
            if(text[i]=="w"||text[i]=="W"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("w.png"));};
            if(text[i]=="x"||text[i]=="X"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("x.png"));};
            if(text[i]=="y"||text[i]=="Y"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("y.png"));};
            if(text[i]=="z"||text[i]=="Z"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("z.png"));};
            if(text[i]==" "){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("space.png"));};

             if(text[i]==","){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("fontCommas.png"));};
            if(text[i]=="."){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("fontDot.png"));};
            if(text[i]=="0"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font0.png"));};
            if(text[i]=="1"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font1.png"));};
            if(text[i]=="2"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font2.png"));};
            if(text[i]=="3"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font3.png"));};
            if(text[i]=="4"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font4.png"));};
            if(text[i]=="5"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font5.png"));};
            if(text[i]=="6"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font6.png"));};
            if(text[i]=="7"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font7.png"));};
            if(text[i]=="8"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font8.png"));};
            if(text[i]=="9"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font9.png"));};


            // if(text[i]==","){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00058.png"));};
            // if(text[i]=="."){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00059.png"));};
            // if(text[i]=="0"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00048.png"));};
            // if(text[i]=="1"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00049.png"));};
            // if(text[i]=="2"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00050.png"));};
            // if(text[i]=="3"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00051.png"));};
            // if(text[i]=="4"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00052.png"));};
            // if(text[i]=="5"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00053.png"));};
            // if(text[i]=="6"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00054.png"));};
            // if(text[i]=="7"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00055.png"));};
            // if(text[i]=="8"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00056.png"));};
            // if(text[i]=="9"){this.result[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("font_00057.png"));};


            this.result[i].x=i*this.spacing;
            this.result[i].anchor.set(0.5)
            this.parent.addChild(this.result[i])
            

            // this.tintImages();
        }   
        
    }


    public setAnchor(newVal:Array<number>)
    {
        for (let i = 0; i < this.result.length; i++) {
            this.result[i].anchor.set(newVal[0],newVal[1])
            
        }
    }
    private updateSpaceing()
    {
        for (let i = 0; i <  this.result.length; i++) {
            
            this.result[i].x=i*this.spacing;
        }
    }

    public getParent=():PIXI.Container=>
    {
        return this.parent;
    }
    private clean=():void=>
    {
        for (var i = this.parent.children.length - 1; i >= 0; i--)
        {	
            this.parent.removeChild(this.parent.children[i]);
        };
    }
    public setAlpha=(alhaVal:number):void=>
    {
        this.parent.alpha=alhaVal;
    }
    public setNewText=(text:string):void=>
    {
        this.clean();
        this.text=text;
        this.buildText(text)
    }
    public getText=():string=>
    {
        return this.text;
    }
    public setSpacing=(newValue:number):void=>
    {
        this.spacing =newValue;
        this.updateSpaceing()
    }
    
    private tintImages=():void=>
    {
        for (let i = 0; i < this.result.length; i++) {
            this.result[i].tint=this.newTint;
            
        }
    }
    public setTint=(newTint:number):void=>
    {   

        this.newTint=newTint;
        this.tintImages();
     
    }
    public setScale=(newScaleVal:number):void=>
    {
        this.parent.scale.set(newScaleVal);
    }
 
}